import InvoiceTableCard from "./InvoiceTableCard";

export default InvoiceTableCard;
